"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    attach: function () { },
    detach: function () { },
};



//////////////////
// WEBPACK FOOTER
// ./~/focus-lock/dist/es5/tabHook.js
// module id = 577
// module chunks = 0